<template>
<van-tabbar :active="active" active-color="#A40001" safe-area-inset-bottom placeholder @change="tabbarChange">
  <van-tabbar-item>
    <template #icon="props">
      <img :src="props.active ? require('@/assets/icon/index_a.png') : require('@/assets/icon/index.png')" />
    </template>
    <span>主页</span>
  </van-tabbar-item>
  <van-tabbar-item>
    <template #icon="props">
      <img :src="props.active ? require('@/assets/icon/ziyuan_a.png') : require('@/assets/icon/ziyuan.png')" />
    </template>
    <span>资源</span>
  </van-tabbar-item>
  <van-tabbar-item v-if="false">
    <template #icon="props">
      <img :src="props.active ? require('@/assets/icon/store_a.png') : require('@/assets/icon/store.png')" />
    </template>
    <span>商城</span>
  </van-tabbar-item>
  <van-tabbar-item v-if="false">
    <template #icon="props">
      <img :src="props.active ? require('@/assets/icon/mine_a.png') : require('@/assets/icon/mine.png')" />
    </template>
    <span>我的</span>
  </van-tabbar-item>
</van-tabbar>
</template>

<script>
export default {
  props: {
    active: {
      type: String,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
  },
  computed: {},
  data() {
    return {};
  },
  onLoad() {},
  methods: {
    async tabbarChange(e) {
      console.log(e);
      switch (e.detail) {
        case 0:
          this.$router.push('./index')
          break;
        case 1:
          this.$router.push('./file')
          break;
          // case 2:
          //   toast('敬请期待')
          //   break;
        case 2:
         
          if (localStorage.getItem('userdata')) {
            this.$router.push('./file');
          } else {
            this.$router.push('./login')
          }
          break;
        default:
          break;
      }
      return

    },
  },
};
</script>

<style scoped>
.price-card {
  width: 100%;
  height: 150px;
  margin-top: 18px;
  display: flex;
  padding: 0 18px;
  box-sizing: border-box;
}

.price-card:last-of-type {
  margin-bottom: 0;
}

.price-cover {
  width: 266px;
  height: 150px;
  border-radius: 12px;
  overflow: hidden;
  display: block;
  flex: 0 0 266px;
  margin-right: 26px;
}

.price-msg {
  flex: 0 0 200px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  width: 200px;
}

.price-name {
  font-size: 28px;
  color: #333;
  font-weight: 600;
  width: 100%;
  margin-bottom: 20px;
}

.price-des {
  font-size: 24px;
  color: #666;
  font-weight: 400;
  width: 100%;
  margin-bottom: 24px;
}

.price {
  font-size: 24px;
  color: #ff4d41;
  font-weight: 600;
}
</style>>
